const AUDIT_TRAIL_RULES = ['ASSORTMENT_RULES']

export type AuditTrailRule = (typeof AUDIT_TRAIL_RULES)[number]

export const LAST_UPDATED_ASSORTMENT_LOG = 'lastUpdatedAssortementLog'
export const LAST_UPDATED_PRICING_ASSUMPTION_LOG = 'lastUpdatedPricingAssumptionLog'
